import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndPoint';

export interface LoginRequest {
  referenceId: string;
  pin: string;
}

export interface UserDetails {
  firstName: string;
  lastName: string;
  typeOfStudent: string;
  amount: number;
  email: string;
  paymentStatus: string;
}

export interface LoginResponse {
  success: boolean;
  message: string;
  token: string | null;
  userDetails: UserDetails | null;
  refreshToken?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ReferencepinloginService {
  constructor(private http: HttpClient, private urlSignature: UrlSignature) {}

  login(loginData: LoginRequest): Observable<LoginResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    console.log('Making login request to:', this.urlSignature.referencepinloginurl);

    return this.http
      .post<LoginResponse>(this.urlSignature.referencepinloginurl, loginData, {
        headers
      })
      .pipe(
        tap((response) => {
          console.log('Login service received response:', response);
          if (response && response.success && response.token && response.userDetails) {
            this.storeToken(response.token);
            this.storeUserDetails(response.userDetails);
            if (response.refreshToken) {
              this.storeRefreshToken(response.refreshToken);
            }
          }
        }),
        catchError((error: HttpErrorResponse) => {
          console.log('=== SERVICE ERROR HANDLER ===');
          console.log('Error status:', error.status);
          console.log('Error error:', error.error);
          console.log('Error message:', error.message);
          console.log('Full error:', error);
          
          // The error.error should contain the LoginResponse object from backend
          // Just throw it as-is, the component will handle it
          return throwError(() => error);
        })
      );
  }

  storeToken(token: string): void {
    sessionStorage.setItem('authToken', token);
  }

  storeUserDetails(userDetails: UserDetails): void {
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
  }

  getToken(): string | null {
    return sessionStorage.getItem('authToken');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  storeRefreshToken(token: string): void {
    sessionStorage.setItem('refresh_token', token);
  }
  
  getRefreshToken(): string | null {
    return sessionStorage.getItem('refresh_token');
  }

  refreshToken(refreshToken: string): Observable<any> {
    return this.http.post<any>(
      this.urlSignature.refreshTokenUrl,
      { refreshToken },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  logout(): void {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('userDetails');
    sessionStorage.removeItem('refresh_token');
  }
}